import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogActionsComponent } from '~shared/modules/catalog/catalog-products-list/modules/catalog-actions/catalog-actions.component';
import { SortTogglerComponent } from '~shared/modules/catalog/catalog-products-list/modules/catalog-actions/sort-toggler/sort-toggler.component';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { MmSelectModule } from '~shared/modules/mm-select/mm-select.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmFlexLayoutModule,
    MmSelectModule,
    MmIconModule,
    MmButtonModule,
  ],
  declarations: [CatalogActionsComponent, SortTogglerComponent],
  exports: [CatalogActionsComponent, SortTogglerComponent],
})
export class CatalogActionsModule {}
